export interface Question {
  id: string;
  text: string;
  type?: "percent";
  rangeOfNote?: (v: number) => boolean;
  details?: string;
  answers?: Array<string>;
  answersOfNote?: Array<number>;
  statement: string;
  emoji: string;
  tenantUnion?: boolean;
  hidden?: boolean;
}

export interface Selection {
  id: string;
  text: string;
  emoji: string;
}

export interface SelectQuestions {
  questions: Array<Selection>;
  emoji: string;
}

export const qs: Question[] = [
  {
    id: "income-rent",
    text: "About how much of your income goes to rent here?",
    type: "percent",
    statement: "<answer> of their income goes to rent",
    emoji: "✉️",
  },
  {
    id: "rent-increase",
    text: "How much has your rent gone up in the past year?",
    answers: [
      "None",
      "Less than $60",
      "Between $60 and $150",
      "More than $150",
    ],
    answersOfNote: [1, 2, 3],
    statement: "their rent went up <answer>",
    emoji: "💵",
  },
  {
    id: "maintenance",
    text: "Does this landlord respond to maintenance problems?",
    answers: ["Yes", "No", "Slow to respond"],
    answersOfNote: [1, 2],
    statement: "this landlord <answer> responds to maintenance problems",
    emoji: "🛠️",
  },
  {
    id: "unprofessional",
    text: "Is this landlord unprofessional or creepy? ",
    details:
      "(unwanted comments, rude, aggressive, privacy violations, retaliation)",
    answers: ["Yes", "No"],
    answersOfNote: [0],
    statement: "this landlord is <answer> unprofessional or creepy",
    emoji: "🛑",
  },
  {
    id: "unsafe",
    text: "Is this building unlivable or unsafe?",
    details: "(mold, pests, leaks, maintenance needs, insufficient heat)",
    answers: ["Yes", "No"],
    answersOfNote: [0],
    statement: "this building has untreated mold or other biohazards",
    emoji: "☣️",
    hidden: true,
  },
  {
    id: "eviction",
    text: "Has this landlord attempted to evict you for any reason?",
    answers: ["Yes", "No"],
    answersOfNote: [0],
    statement: "this landlord attempted to evict them",
    emoji: "⚖️",
  },
  {
    id: "tenant-union",
    text: "Would you start or join a tenant union?",
    answers: ["Yes", "No", "Interested in learning more"],
    answersOfNote: [0],
    statement: "this landlord attempted to evict them",
    emoji: "👥",
    tenantUnion: true,
  },
  // {
  //     text: 'Is your building unlivable?',
  //     answers: [
  //         'Yes',
  //         'Sometimes',
  //         'No'
  //     ],
  //     answersOfNote: [0, 1],
  //     statement: 'this building is <1|answer> unlivable'
  // }
];

export const selectionQuestions: SelectQuestions = {
  // text: 'Is this building unlivable or unsafe?',
  // details: '(mold, pests, leaks, maintenance needs, insufficient heat)',
  // answers: [
  //     'Yes',
  //     'No'
  // ],
  // answersOfNote: [0],
  // statement: 'this building has untreated mold or other biohazards',
  // emoji: '☣️'
  emoji: "❗",
  questions: [
    {
      id: "unsafe",
      text: "unsafe living conditions",
      emoji: "☣️",
    },
    {
      id: "mold",
      text: "mold or moisture",
      emoji: "🦠",
    },
    {
      id: "leaks",
      text: "leaks or holes",
      emoji: "🔧",
    },
    {
      id: "airflow",
      text: "insufficient airflow",
      emoji: "💨",
    },
    {
      id: "windows",
      text: "inoperable windows",
      emoji: "🪟",
    },
    {
      id: "heat",
      text: "insufficient heat",
      emoji: "🌡️",
    },
    {
      id: "wiring",
      text: "faulty wiring",
      emoji: "⚡",
    },
    {
      id: "pests",
      text: "pests",
      emoji: "🐀",
    },
    {
      id: "plumbing",
      text: "plumbing issues",
      emoji: "🚰",
    },
    {
      id: "water",
      text: "bad water quality",
      emoji: "💧",
    },
    {
      id: "smoke-detector",
      text: "smoke detector issues",
      emoji: "🔥",
    },
    {
      id: "intimidation",
      text: "intimidation from landlord",
      emoji: "😡",
    },
    {
      id: "ADA",
      text: "ESA/ADA discrimination",
      emoji: "♿",
    },
    {
      id: "race",
      text: "race discrimination",
      emoji: "🚫",
    },
    {
      id: "security-deposit",
      text: "security deposit theft",
      emoji: "💰",
    },
    // {
    //     text: 'unable to see unit before move-in',
    //     emoji: '👀'
    // },
    {
      id: "misleading",
      text: "misleading unit listing",
      emoji: "📝",
    },
  ],
};

export type Landlord = { name: string; origin: string };
